import ExternalCardDetails from 'features/myVaro/screens/ExternalAccounts/ExternalCardDetails';
import React from 'react';

export default function ExternalAccountDetailsPage() {
  return <ExternalCardDetails />;
}
